import React from 'react'

const Desserts = () => {
  return (
    <div className="pt-6">

    <h1 className="font-Bree text-white text-4xl ">DESSERT </h1>
    
     /*Vegetarian menu starts */
       <ul className="font-Monty text-white font-bold">
        <li><span className="px-4">BROWNIE WITH ICE CREAM</span> <span className="text-2xl">200-/-</span> </li>
        <li><span className="px-4">CHOCOLAVA CAKE</span ><span className="text-2xl">90-/-</span> </li>
        <li><span className="px-4">BLUEBERRY MUFFIN</span><span className="text-2xl">90-/-</span> </li>
        <li><span className="px-4">CHOCOCHIP MUFFIN</span> <span className="text-2xl">70-/-</span> </li>
       
       </ul>
     /*Vegetarian Menu Ends */
     
     
    
  </div>
  )
}

export default Desserts